import { httpClient } from '@/infra/protocols/http';
import { IScriptDTO } from '@/modules/scripts/dtos/script.dto';
import { IScript } from '@/modules/scripts/entities/script.entity';
import { ScriptMapper } from '@/modules/scripts/mappers/script.mapper';

export async function createScript(
  params: CreateScriptService.Params,
  data: CreateScriptService.Payload,
): Promise<CreateScriptService.Response> {
  const body = { texto: data.text, ordem: data.order };

  const response = await httpClient.post<IScriptDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro`,
    body,
  );

  return ScriptMapper.toPresentation(response);
}

export namespace CreateScriptService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }
  export interface Payload {
    text: string;
    order: number;
  }
  export type Response = IScript;
}
